import type { RefObject } from 'react';
import type { AssetFile } from '../../../../assetDetail.types';
import type { MediaBox } from '../../hooks/useMediaBox';
import { useMinimapPreview } from './useMinimapPreview';
import { useTranslation } from 'react-i18next';

interface Props {
  file: AssetFile;
  containerRef: RefObject<HTMLElement | null>;
  imageBox: MediaBox | null;
}

export function MinimapPreview({ file, containerRef, imageBox }: Props) {
  const { t } = useTranslation('projects');

  const view = useMinimapPreview({ containerRef, imageBox });
  if (!view || !file.downloadUrl) return null;

  const { miniW, miniH, rect, handlers } = view;

  return (
    <button
      type="button"
      aria-label={t('projectDetail.minimapPreview.dragToPanViewport')}
      className="absolute top-2 right-2 cursor-grab touch-none overflow-hidden rounded-md border border-border bg-black/40 p-0 shadow-md active:cursor-grabbing"
      style={{ width: miniW, height: miniH }}
      {...handlers}
    >
      <img
        src={file.downloadUrl}
        alt=""
        className="pointer-events-none block h-full w-full object-contain select-none"
        draggable={false}
      />
      <div
        className="pointer-events-none absolute border-2 border-white/90 bg-white/10 shadow-[0_0_0_1px_rgba(0,0,0,0.4)]"
        style={{ left: rect.left, top: rect.top, width: rect.width, height: rect.height }}
      />
    </button>
  );
}
